import React, { Component } from 'react';
import { COLORS } from '../styles/colors';
import YouTubeVideoPreview from './YouVideoPreview'
import { GENERAL_HELP_CONTENT } from '../constants';
import Button from '@material-ui/core/Button';
/**
 * Partners
 */
export class Help extends Component {

  constructor(props) {
    super(props);
    this.state = {
      emailInput: '',
      showSentMessage: false,
      isOpen: false,
      videoId: null
    }
    this.openModal = this.openModal.bind(this)
    this.moveToResourceGuide = this.moveToResourceGuide.bind(this)
  }

  openModal(videoId) {
    this.setState({ isOpen: true, videoId: videoId })
  }

  moveToResourceGuide() {
      window.open("https://docs.google.com/document/d/1ZQk8mOoO1rXY3Pc6IkNt7HXA5KfL2HxHAv2qFw8tJ7g/edit");
  }

  moveToStripeResourceGuide() {
    window.open("https://docs.google.com/document/d/1GmE379wA6J9CuDhJke17a65kH_hd0LEUXHhFACnufqU/edit?usp=sharing");
  }

  render() {
    return (
      <div>
        <h1>Help</h1>
        <hr />
        <div style={{ padding: '15px 0px' }}>
          We have created a library of video tutorials to help you quickly learn how to use the Fitbanx platform.
        </div>
        <div style={{
          border: '1px solid ' + COLORS.grey
        }}>
          <YouTubeVideoPreview title={'Help'} channel='youtube' isOpen={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
          <div style={{
            width: '100%',
            borderBottom: '1px solid ' + COLORS.grey,
            textAlign: 'center',
            background: COLORS.greyFour,
            padding: 15,
            fontWeight: 'bold'
          }}>
            Video Tutorials
          </div>
          <div style={{
            padding: 15
          }}>
            {
              GENERAL_HELP_CONTENT.map((link, index) => (
                <div key={index} className="link" onClick={() => this.openModal(link.videoId)} style={{
                  color: COLORS.orange
                }}>
                  {link.text}
                </div>
              ))
            }
          </div>
        </div>
        <div style={{ width: '100%', textAlign: 'center', padding: 15 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.moveToResourceGuide}
              style={{
                backgroundColor: COLORS.orange
              }}
          >
              ONE PAGE RESOURCE GUIDE
          </Button> 
          <Button
              variant="contained"
              color="secondary"
              onClick={this.moveToStripeResourceGuide}
              style={{
                backgroundColor: COLORS.saveBlue,
                marginLeft: '10px',
                width: '242px'
              }}
          >
              STRIPE RESOURCE GUIDE
          </Button>
           <br></br><br></br>  
            Need something else? Send us an email at <span style={{
                  color: COLORS.orange
                }}><a href="mailto:support@Fitbanx.com">support@Fitbanx.com</a></span>
        </div>
      </div>
    );
  }
}


export default Help;



// WEBPACK FOOTER //
// ./src/components/Help.js